export default __webpack_public_path__ + "static/media/img-0488-andorra-half-face.2dfd4162.png";